import { render } from "./Register.vue?vue&type=template&id=3bcfb9ca&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=3bcfb9ca&scoped=true&lang=css"
import "./Register.vue?vue&type=style&index=1&id=3bcfb9ca&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcfb9ca"]])

export default __exports__